import {
  ExploreBaseFilterSchema,
  ExploreFilterComponentProps,
  ExploreTypeFilterSchema,
} from "@modules/new-explore/types";
import CheckBoxFilter from "./explore-checkbox";
import useExplorePreloadedData from "@templates/new-explore/hooks/useExplorePreloadedData";

const ExploreType: React.FC<ExploreFilterComponentProps> = () => {
  const { filtersData } = useExplorePreloadedData();
  const data = (
    filtersData?.type as ExploreBaseFilterSchema & ExploreTypeFilterSchema
  ).data;

  return <CheckBoxFilter filterName="type" item={data} />;
};

export default ExploreType;
